import assocIndexOf from './_assocIndexOf.js';

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

export default listCacheSet;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_listCacheSet.js
// module id = 2356
// module chunks = 0